import Cta from '../../components/Cta'
import ReactGA from "react-ga4"

import { useDeal } from '../../providers/DealProvider';

function DealCard(props) {
  let deal = props.deal;
  let bgColor = deal.bgColor || 'c0ccda';
  let logoColor = deal.logoColor || 'ffffff';

  let containerClass = `box-border relative border p-4 rounded-t-lg flex flex-col overflow-hidden group-hover:outline-card-top`;
  let containerStyle = {
    backgroundColor: `#${bgColor}43`,
    borderColor: `#${bgColor}43`
  };

  let logoClass = `w-16 h-16 p-2 flex justify-center rounded-2xl`;
  let logoStyle = {
    backgroundColor: `#${logoColor}`
  }

  let currentStyle = 'inline-flex items-center justify-center px-14 py-4 border border-blue-700 font-cta-label font-medium text-cta-label-mobile lg:text-cta-label rounded-full text-black bg-white group-hover:text-white group-hover:bg-blue-700';
  let buttonLabel = 'Offer Details'; // Todo: Change based on login status

  const setOpenQuickView = props.setOpenQuickView;
  const setProduct = props.setProduct;
  const [state, dispatch] = useDeal();

  deal.imageAlt = `${deal.vendor.name} logo`


  const openQuickView = () => {
    /*
    ReactGA.gtag("event", "view_item", {
      currency: "USD",
      value: 0,
      items: [
        {
          item_id: deal.id,
          item_name: deal.name,
          item_list_id: "marketplace_grid",
          item_list_id: "Marketplace Grid",
        }
      ],
    });
    */
    window.dataLayer.push({
      event: 'view_offer',
      eventProps: {
        offer: {
          offer_id: deal.id,
          offer_name: deal.name,
          vendor_id: deal.vendor.id,
          vendor_name: deal.vendor.name
        }
      }
    });
    let idx = Math.floor(Math.random() * state.deals.length-4);

    deal.category = deal.category.map((category) => {
      let display = state.categories.filter((cat) => {
        return cat.key == category;
      });
      return display.pop();
    }).filter(x => x);

    dispatch({ type: "quickview/open", payload: { deal: deal, relatedDeals: state.deals.slice(idx, idx+4) } });
    //setOpenQuickView(true);
    //setProduct(deal);
  }

  return(
    <div onClick={ openQuickView } className="group cursor-pointer mx-auto w-[324px] xl:w-full">
      <div
        key={deal.id}
        style={containerStyle}
        className={containerClass}
      >
        <div 
          className={logoClass}
          style={logoStyle}
        >
          <img
            src={deal.vendor.image || ""}
            alt={deal.imageAlt}
            className="object-center object-contain"
          />
        </div>
        <div className="flex-1 mt-4 flex flex-col">
          <div className="lg:min-h-[48px]">
            <h3 className="font-secondary text-headline-5 2xl:text-headline-4">
              {deal.vendor.name}: {deal.name}
            </h3>
          </div>
          <div className="lg:min-h-[41px] font-deal-card-desc text-offer-card-body 2xl:text-offer-card-body-2xl text-black">
            <p style={{ overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }} className="">{deal.shortDesc}</p>
          </div>
        </div>
      </div>

      <div className="flex flex-row items-center justify-center bg-white py-4 text-center border rounded-b-xl group-hover:outline-card">
        <div className="font-secondary font-weight-700 text-convoy-aqua text-headline-3 uppercase mt-[3px] mr-2">{deal.averageSavings}</div>
        <div className="font-primary text-overline uppercase">Average Savings</div>
      </div>
    </div>
  )
}

export default DealCard;
